import { ComponentProps } from "react";

interface DeleteIconProps extends ComponentProps<"svg"> {
  color?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export default function DeleteIcon(props: DeleteIconProps) {
  const { color = "currentColor", width = 20, height = 20, style, ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      style={style}
    >
      <path d="M3 6.33203H16.3333" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 9.66797V14.668" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.332 9.66797V14.668" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M3.83203 6.33203L4.66536 16.332C4.66536 16.7741 4.84096 17.198 5.15352 17.5105C5.46608 17.8231 5.89 17.9987 6.33203 17.9987H12.9987C13.4407 17.9987 13.8646 17.8231 14.1772 17.5105C14.4898 17.198 14.6654 16.7741 14.6654 16.332L15.4987 6.33203"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.16797 6.33333V3.83333C7.16797 3.61232 7.25577 3.40036 7.41205 3.24408C7.56833 3.0878 7.78029 3 8.0013 3H11.3346C11.5556 3 11.7676 3.0878 11.9239 3.24408C12.0802 3.40036 12.168 3.61232 12.168 3.83333V6.33333"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
